var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.19 7.193 8.665 8.727V2.333a.667.667 0 0 0-1.333 0v6.394L5.804 7.193a.667.667 0 0 0-1.093.217.667.667 0 0 0 .146.73l2.667 2.667c.063.06.138.108.22.14a.666.666 0 0 0 .507 0 .666.666 0 0 0 .22-.14l2.666-2.667a.668.668 0 0 0-.73-1.092.67.67 0 0 0-.216.145Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 14.33h13.334",
    stroke: "#999",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f740139cb3a5fa605710a4354e4f4a02.svg";
export { ForwardRef as ReactComponent };